import {
  TypographyElement
} from 'UI'
import CreditCard from 'components/common/CreditCard'
import SavedCard from 'components/common/CreditCard/savedCard'
import { splitPayments } from 'helpers'
import { useEffect, useState } from 'react'
import { morrocanCurrency } from 'store/currency'

import Text from './text.json'
import { useTheme } from 'react-jss'

const cardsLoading = [...Array(2).fill({ loading: true })]

export default ({ cards, fetchCards, changeDefaultPaymentMethodAction, hideChange, titleProps, noTitle, deleteCard, deletePaypal, changeTypographyProps = {}, loadingCreditCards, currency }) => {
  const theme = useTheme()
  useEffect(() => { fetchCards() }, [])

  const [cmiPaymentMethod, otherPaymentMethods] = splitPayments(cards)
  const [currentCards, setCurrentCards] = useState(otherPaymentMethods)

  useEffect(() => {
    if (currency === morrocanCurrency) {
      setCurrentCards(cmiPaymentMethod)
    } else {
      setCurrentCards(otherPaymentMethods)
    }
  }, [currency, cards])

  const [showForm, setShowForm] = useState(currentCards.length === 0)

  useEffect(() => {
    if (currentCards.length) {
      setShowForm(false)
    } else {
      setShowForm(true)
    }
  }, [currentCards, currency])

  return (
    <>
      {
        !noTitle &&
          <TypographyElement
            component='h3'
            variant='heading5'
            spacing='0 0 16px 0'
            {...titleProps}
          >
            {Text.paymentMethods}
          </TypographyElement>
      }
      {
        showForm
          ? <CreditCard cartMode />
          : (
            <>
              {(loadingCreditCards ? cardsLoading : currentCards).map(card => <SavedCard key={card.Id} card={card} changeDefaultPaymentMethodAction={changeDefaultPaymentMethodAction} deleteCard={deleteCard} deletePaypal={deletePaypal} />)}
              {
                !hideChange &&
                  <TypographyElement
                    variant='body1'
                    cursor='pointer'
                    handleClick={() => setShowForm(!showForm)}
                    color={theme.primary[0]}
                    {...changeTypographyProps}
                  >
                    {Text.change}
                  </TypographyElement>
              }
            </>
            )
      }
    </>
  )
}
